// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 10H3.5V22H20.5V10H18V7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7V10ZM8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V10H8V7ZM9 17V15H15V17H9Z"}}]};

const LockOnFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lock-on-filled',
    ref,
    icon: element,
  },
));

LockOnFilledIcon.displayName = 'LockOnFilledIcon';

export default LockOnFilledIcon;
